import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, MaterialTransfer, RepositoryModal } from '../../shared'
import { MaterialTransferRecordsComponent } from './material-transfer-records.component'

@Component({
    templateUrl: './material-transfer-record.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class MaterialTransferRecordComponent extends RepositoryModal<MaterialTransfer> {
    materialList: ListItem<string>[] = []
    locationList: ListItem<string>[] = []
    activeUserList: ListItem<number>[] = []

    protected onInitialized() {
        const controller = this.editOptions.initializeParams as MaterialTransferRecordsComponent
        this.materialList = controller.materialMap.collectionView.items.map(x => new ListItem(x.barcode, x.name))
        this.locationList = controller.locationMap.collectionView.items.map(x => new ListItem(x.key, x.value))
        this.activeUserList = controller.activeUsers.map(x => new ListItem(x.id, x.name))
    }

    protected onBeforeSave() {
        return super.onBeforeSave()
    }
}
